module.exports = __webpack_public_path__ + "media/images/pdficonsVideo-1450bd1a.png";